import App from './CMUWallApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iCMUWall', <App />);
